import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Offcanvas } from "react-bootstrap";

import QueryForm from "./ContactUsTab/QueryForm";
import SamsaOffices from "./ContactUsTab/SamsaOffices";
import EmergencyNumber from "./ContactUsTab/EmergencyNumber";
import BoardCeo from "./ContactUsTab/BoardCeo";
import WHISTLEBLOWING from "./ContactUsTab/WHISTLEBLOWING";

const sectionComponents = {
  "query-form": <QueryForm />,
  "samsa-offices": <SamsaOffices />,
  "emergency-number": <EmergencyNumber />,
  "Board-Ceo": <BoardCeo />,
  "WHISTLE-BLOWING": <WHISTLEBLOWING />,
};

function ContactUsTab() {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentSection, setCurrentSection] = useState("query-form");
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const fromState = location.state?.section;
    const fromQuery = queryParams.get("section");
    setCurrentSection(fromState || fromQuery || "query-form");
  }, [location.state, location.search]);

  const handleClick = (sectionId) => {
    setCurrentSection(sectionId);
    setShowOffcanvas(false);

    const params = new URLSearchParams(location.search);
    params.set("section", sectionId);
    navigate(`${location.pathname}?${params.toString()}`);
  };

  useEffect(() => {
    if (location.pathname.startsWith("/contact-us")) {
      const queryParams = new URLSearchParams(location.search);
      const el = document.getElementById(currentSection);
      if (el && queryParams.get("section") !== null) {
        const yOffset = -150;
        const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
        setTimeout(() => {
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 100);
      } else {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      }
    }
  }, [currentSection,location.pathname,location.search]);

  return (
    <section className="ManagementTeam px-3 small-anchor" id="ManagementTeam">
      <div className="container max-1330 mx-auto">
        <div className="row g-3 g-sm-4 g-md-5">
          <div className="col-lg-3 col-md-4">
            <div className="position-stiicky top-150">
              <div className="d-md-none text-end">
                <Button variant="link" onClick={() => setShowOffcanvas(true)} className="border-0 p-0">
                  <i className="bi bi-list font-32"></i>
                </Button>
              </div>

              <Offcanvas show={showOffcanvas} onHide={() => setShowOffcanvas(false)} responsive="md" placement="end">
                <Offcanvas.Header closeButton className="d-md-none">
                  <Offcanvas.Title>Contact Us</Offcanvas.Title>
                </Offcanvas.Header>
                <div className="offcanvas-md offcanvas-end">
                  <div
                    className="accordion leftMenu px-3 px-md-0 pb-3 pb-md-0 overflow-auto overflow-md-visible"
                    id="accordionExample"
                  >
                    {[
                      { key: "query-form", label: "QUERY FORM" },
                      { key: "samsa-offices", label: "SAMSA OFFICES" },
                      {key: "Board-Ceo", label: "SAMSA BOARD AND CEO"},
                      { key: "emergency-number", label: "EMERGENCY NUMBER" },
                      {key: "WHISTLE-BLOWING", label:"WHISTLEBLOWING"}
                      
                    ].map(({ key, label }, idx) => (
                      <div className="accordion-item" key={key}>
                        <h2 className="accordion-header">
                          <button
                            className={`accordion-button ${currentSection === key ? "collapsed gray-active" : "collapsed"}`}
                            onClick={() => handleClick(key)}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${idx}`}
                            aria-expanded="false"
                            aria-controls={`collapse${idx}`}
                          >
                            {label}
                          </button>
                        </h2>
                      </div>
                    ))}
                  </div>
                </div>
              </Offcanvas>
            </div>
          </div>

          <div className="col-lg-9 col-md-8">
            <div className="vertical-scrol" id={currentSection}>
              <div>{sectionComponents[currentSection]}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUsTab;
